<template>
  <div class="home">
    <van-tabs
      v-model="active"
      background="#1883fe"
      color="#fff"
      line-width="2rem"
      title-inactive-color="#fff"
      title-active-color="#47d3ff"
      :sticky="true"
    >
      <van-tab title="本周">
        <week />
      </van-tab>
      <van-tab title="本月">
        <mouth />
      </van-tab>
      <van-tab title="本年">
        <year />
      </van-tab>
    </van-tabs>
    <tabber></tabber>
  </div>
</template>

<script>
import tabber from "@/components/tabber/tabber.vue";
import week from './components/week.vue'
import mouth from './components/mouth.vue'
import year from './components/year.vue'
export default {
  name: "home",
  components: {
    tabber,week,mouth,year
  },
  data() {
    return {
      active: 0,
    };
  },
  created() {},
  methods: {},
};
</script>

<style scoped lang="less">
.home {
  width: 100%;
  min-height: 100vh;
  padding-bottom: 1.4rem;
  overflow: hidden;
  background-color: #eef2f6;
}
</style>